export default __webpack_public_path__ + "static/media/Cancelled.d19d2c83.svg";